import React from "react";
import CollapsibleWrapper from "../CollapsibleWrapper";
import UnifiedContentRenderer from "./core/UnifiedContentRenderer";

const DefaultMessageContent = ({
  msg,
  messageId,
  initialExpanded,
  onToggle,
  shouldCollapseByValue,
  renderCopyButton,
  styles,
}) => {
  return (
    <div className={`message-content-wrapper ${styles.messageContentWrapper || ""}`}>
      <CollapsibleWrapper
        messageId={messageId}
        collapsible={shouldCollapseByValue(msg.context)}
        initialExpanded={initialExpanded}
        onToggle={onToggle}
      >
        <div className={styles.messageContent}>
          <UnifiedContentRenderer
            content={msg.context}
            isStreaming={Boolean(msg.isStreaming || msg.streaming || msg.type === 'StreamingMsgtoHuman')}
          />
        </div>
      </CollapsibleWrapper>
      {renderCopyButton(msg.context)}
    </div>
  );
};

export default React.memo(DefaultMessageContent);
